import * as Config from '../config';
import { useState, useEffect } from "react";

const useApiOrLocal = (api, path = null, data = []) => {
  const [items, setItems] = useState(null);

  useEffect(() => {
    if (api) {
      if (path) {
        api.getFromApi(path, false)
          .then( (response) => {
            const dataResults = (path.includes('/my/playlists')) ? response.data.results.map( x => { x.track.item_id = x.id; return x.track } ) : response.data.results;
            setItems(dataResults.map(Config.formattedFromBP));
          })
          .catch( e => console.log(`error getFromApi`, e) );
      } else {
        setItems(data.map(Config.formatted));
      }
    }
  }, [api, data, path])

  return { items };
};

export default useApiOrLocal;
